/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useCallback } from 'react';

import {
  IconButton,
  Typography,
  TextField,
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  LinearProgress
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Add,
  CheckOutlined,
  CloseOutlined,
  DeleteOutline
} from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import axios from 'axios';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Alert } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { Tree } from 'shineout';

import CommonAlert from 'components/CommonAlert/CommonAlert';
import PageTitleAndFilter from 'components/PageTitleAndFilter';
import SwitchField from 'components/PageTitleAndFilter/SwitchField/SwitchField';
import TreeSelectorField from 'components/PageTitleAndFilter/TreeSelectorField';
import TitleHead from 'components/TitleHead';
import Layout from 'containers/layouts/layout';
import categoriesExpand from 'images/icons/signals/addsAndCreates/categoriesExpand.svg';
import categoriesCollapsed from 'images/icons/signals/removesAndDeletes/categoriesCollapsed.svg';
import axiosInstanceCatalog from 'services/middlewares/apis/catalog_validate';
import * as UserActions from 'store/actions/user';
import { Container, GlobalStyle } from 'styles/general';
import Environment from 'utils/environments';

import ProductItemCategory from './ProductItemCategorie';
import { SwitchContainer, SwitchDescription } from './style';

function RegisterCategoriesPrinter({ userInfo }) {
  const [alertErrorDuplicated, setAlertErrorDuplicated] = useState(false);
  const [alertErrUpdate, setAlertErrUpdate] = useState(false);
  const [alertErrDelete, setAlertErrDelete] = useState(false);
  const [alertErr, setAlertErr] = useState(false);
  const closeMessage = () => setAlertErrorDuplicated(false);
  const onDismiss = () => setAlertErr(false);
  const onDismissUpdate = () => setAlertErrUpdate(false);
  const onDismissDelete = () => setAlertErrDelete(false);
  const { id: paramsID, productId } = useParams();
  const profileType = userInfo.profile[0][0].name;
  const environments = Environment(process.env.REACT_APP_ENV);
  const BaseUrl = `${environments.catalog}/categories`;
  const userLocal = JSON.parse(localStorage.getItem('companies'));
  const [defaultExpanded] = useState(['Delivery']);
  const [expandedTree, setExpandedTree] = useState([]);
  const [description, setDescription] = useState(null);
  const [dataArray, setDataArray] = useState([]);
  const [buttonAddClick, setButtonAddClick] = useState(false);
  const [childId, setChildId] = useState('');
  const [typeClick, setTypeClick] = useState('Shopping');
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [nodeClick, setNodeClick] = useState('');
  const [typeCategory, setTypeCategory] = useState('Shopping');
  const [getId, setGetId] = useState(paramsID);
  const [addRootCategory, setAddRootCategory] = useState('');
  const [deleteHas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hiddenProductsAndSkus, setHiddenProductsAndSkus] = useState(false);
  const [toastError, setToastError] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [statusCode, setStatusCode] = useState();
  const [user, setUser] = useState({
    groups: [],
    subgroups: [],
    stores: []
  });
  const isLabelAdmin = profileType === 'admin_label';
  const isLabelManager = profileType === 'manager_label';
  const labelManagerHasAllPermissions =
    isLabelManager && !userInfo?.labelOnlyRestaurants;
  const currentUserId =
    isLabelAdmin || !labelManagerHasAllPermissions ? userLocal?.labelId : getId;
  const groupsOptions = [userInfo?.companies?.groups[0]];
  const isGroupManage = String(getId)?.includes(',');
  const currentIds = isGroupManage ? String(getId)?.split(',') : currentUserId;

  const useStyles = makeStyles((theme) => ({
    root: {
      minWidth: 275
    },

    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)'
    },

    title: {
      fontSize: '12px',
      fontWeight: 'bold',
      fontFamily: 'Lato',
      color: '#000'
    },

    buttonStyle: {
      display: 'inline-block',
      padding: '6px 4px',
      border: '1px solid #ccc'
    },

    margin: {
      margin: theme.spacing(1)
    },

    Alert: {
      width: '50%',
      height: '30px',
      backgroundColor: 'white',
      border: '1px solid black'
    },

    buttonRow: {
      paddingTop: '20px',
      marginLeft: '55px'
    },

    buttonRowChild: {
      paddingTop: '10px'
    },

    formControl: {
      marginTop: '10px',
      paddingLeft: '10px',
      minWidth: '200px'
    },

    selectEmpty: {
      marginTop: theme.spacing(1)
    },

    paper: {
      width: 200,
      height: 230,
      overflow: 'auto'
    },

    button: {
      margin: theme.spacing(0.5, 0)
    }
  }));

  const classes = useStyles();

  const getCategories = useCallback(
    (typeCategory, customItems) => {
      (async () => {
        setLoading(true);
        const formattedIds = customItems
          ? customItems?.map((el) => el?.id)
          : currentIds;
        const categoriesApiSales = await axiosInstanceCatalog.get(
          `${environments.catalog}/categories?page=1&size=100&originId=${formattedIds}&type=${typeCategory}`
        );
        const data = await categoriesApiSales.data;
        setDataArray(data.content);
        setLoading(false);
      })();
    },
    [currentUserId]
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const config = {
    headers: {
      User: `${userLocal?.user}`
    }
  };

  // adiciona categoria filha
  const addNewObj = () => {
    axios
      .post(
        `${BaseUrl}?updateMenu=true`,
        {
          method: 'POST',
          originId: isGroupManage
            ? user?.stores?.map((el) => el?.id)[0]
            : currentUserId,
          restaurantId: isGroupManage ? user?.stores?.map((el) => el?.id) : '',
          isLabelAdmin,
          description,
          parentId: childId,
          type: typeClick,
          user: userInfo.user
        },
        config
      )
      .then(() => {
        setTimeout(() => getCategories(typeCategory), 300);
      })
      .catch((error) => {
        setToastError(true);
        setMessageError(
          error?.response?.data?.message || error?.response?.data?.error
        );
        setStatusCode(error?.response?.status);
      })
      .finally(() => {
        setButtonAddClick(false);
      });
  };

  const cancelAddObject = () => {
    setButtonAddClick(false);
  };

  // adiciona categoria pai
  const addNewObjPai = () => {
    axios
      .post(
        BaseUrl,
        {
          method: 'POST',
          originId: isGroupManage
            ? user?.stores?.map((el) => el?.id)[0]
            : currentUserId,
          restaurantId: isGroupManage ? user?.stores?.map((el) => el?.id) : '',
          description,
          isLabelAdmin,
          parentId: null,
          type: typeClick,
          user: userInfo.user
        },
        config
      )
      .then(() => {
        setAddRootCategory('');
        setTimeout(() => getCategories(typeCategory), 300);
      })
      .catch((error) => {
        setToastError(true);
        setMessageError(
          error?.response?.data?.message || error?.response?.data?.error
        );
        setStatusCode(error?.response?.status);
      });
  };

  // funcao para remover a categoria
  const removeObj = (node) => {
    axios
      .delete(
        `${environments.catalog}/categories/${node.id}?originId=${currentIds}${deleteHas}`,
        config
      )
      .then(() => {
        setTimeout(() => getCategories(typeCategory), 300);
      })
      .catch((error) => {
        console.log(error);
        setToastError(true);
        setMessageError('Description has been already registered');
        setStatusCode(error?.response?.status);
      });
    handleClose();
  };

  // funcao para mandar a edicao da categoria para o back
  const updateData = (id, description) => {
    if (description !== '') {
      axios
        .put(
          `${environments.catalog}/categories/${id}`,
          {
            description,
            user: userInfo.user
          },
          config
        )
        .then(() => {
          setTimeout(() => getCategories(typeCategory), 300);
        })
        .catch((error) => {
          setToastError(true);
          setMessageError(
            error?.response?.data?.message || error?.response?.data?.error
          );
          setStatusCode(error?.response?.status);
        });
    }
  };

  // estados da categoria filha
  const valuesChild = (node) => {
    setChildId(node.id);
    setButtonAddClick(true);
  };

  // funcao recursiva para contar quantas categorias filhas existe, na pai
  let count;
  const countCategories = (node) => {
    count = node.children.length;
    node.children.forEach((obj) => {
      if (obj.children) {
        count = parseInt(count, 10) + parseInt(obj.children.length, 10);
      } else {
        countCategories(obj.children);
      }
    });
  };

  const deleteCategorie = (node) => {
    countCategories(node);
    setNodeClick(node);

    if (count == 0)
      setMessage(`Deseja realmente deletar a categoria ${node.description}?`);
    else
      setMessage(
        `A categoria ${node.description} possui ${count} categoria(s) filha(s), deseja realmente deletar?`
      );

    handleClickOpen();
  };

  const isDisableAddOrderCategory =
    description === null || description === '' || false;

  const findCategoryElement = (id) => {
    const currentSelectedCategory = document.getElementById(`item-${id}`);
    if (currentSelectedCategory) {
      const element = currentSelectedCategory;

      element.classList.remove('categorieOutlineNoColor');
      element.classList.add('categorieOutline');

      element.focus();
      setTimeout(() => {
        element.classList.remove('categorieOutline');
        element.classList.add('categorieOutlineNoColor');
      }, 2500);
    }
  };

  const handleCategorieValue = (_, currentCategorie, id) => {
    const newTree = [];
    const filterElementInCategory = (
      data,
      value,
      list = [],
      pastElement = []
    ) => {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const element = data[key];
          newTree.push(element);
          if (
            element.description.toLowerCase() === value.toLowerCase() &&
            element.id === id
          ) {
            list.push(element);

            const treePath = [...pastElement, ...list];
            const treeMap = treePath.map((item) => item.description);
            setExpandedTree(treeMap);
            setTimeout(() => {
              findCategoryElement(id);
            }, 150);
          }

          filterElementInCategory(element.children, value, list, [
            ...[element],
            ...pastElement
          ]);
        }
      }
    };
    filterElementInCategory(dataArray, currentCategorie);
  };

  // renderiza os objetos com os botoes edit, del, add
  const renderItem = (node) => (
    <div
      className={!!node.products?.length && !!node.children?.length && 'teste'}
    >
      <TextField
        margin="dense"
        size="small"
        variant="outlined"
        defaultValue={node.description}
        inputProps={{ maxLength: 50 }}
        onBlur={(e) => updateData(node.id, e.target.value)}
        style={{
          width:
            typeCategory === 'Shopping' && profileType !== 'admin'
              ? '180px'
              : '320px'
        }}
        id={`item-${node.id}`}
        disabled={!labelManagerHasAllPermissions && !isLabelAdmin}
      />

      <IconButton
        aria-label="add"
        disabled={node.nivel === 15 || !labelManagerHasAllPermissions && !isLabelAdmin}
        onClick={() => valuesChild(node)}
        style={{ outline: 6 }}
      >
        <Add aria-label="add" fontSize="small" />
      </IconButton>

      <IconButton
        aria-label="delete"
        disabled={!labelManagerHasAllPermissions && !isLabelAdmin}
        onClick={() => deleteCategorie(node)}
        style={{ outline: 6 }}
      >
        <DeleteOutline aria-label="delete" fontSize="small" />
      </IconButton>

      {buttonAddClick && childId === node.id ? (
        <div className="addItemContainer">
          <Grid
            style={{ marginLeft: '16px', paddingTop: 0 }}
            className={classes.buttonRowChild}
            container
            spacing={12}
          >
            <Grid>
              <TextField
                className="textFieldSmall"
                placeholder="Adicionar..."
                size="small"
                variant="outlined"
                inputProps={{ maxLength: 50 }}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                InputLabelProps={{
                  shrink: true
                }}
                disabled={!labelManagerHasAllPermissions && !isLabelAdmin}
              />

              <IconButton
                className="smallIcons"
                aria-label="check"
                onClick={() => addNewObj()}
                style={{ outline: 6 }}
                disabled={
                  isDisableAddOrderCategory || (!labelManagerHasAllPermissions && !isLabelAdmin)
                }
              >
                <CheckOutlined size="small" />
              </IconButton>

              <IconButton
                className="smallIcons"
                aria-label="cancel"
                onClick={() => cancelAddObject()}
                style={{ outline: 6 }}
              >
                <CloseOutlined size="small" />
              </IconButton>
            </Grid>
          </Grid>
        </div>
      ) : null}

      {!!node.products?.length && !hiddenProductsAndSkus && (
        <ProductItemCategory
          node={node}
          userInfo={userInfo}
          refreshCategories={() =>
            getCategories(
              typeCategory,
              isGroupManage ? user?.stores?.map((el) => el?.id) : ''
            )
          }
          labelManagerHasAllPermissions={labelManagerHasAllPermissions}
        />
      )}
    </div>
  );

  // Origin Id
  useEffect(() => {
    setGetId(currentUserId);
  }, [currentUserId]);

  // Categorias
  useEffect(() => {
    const formattedIds = isGroupManage
      ? currentIds?.map((el) => parseFloat(el))
      : [currentUserId];
    const selectedSubGroup = groupsOptions[0]?.subGroups.filter((el) =>
      el?.stores?.some((item) => formattedIds.includes(item?.id))
    );

    if (isGroupManage) {
      setUser({
        ...user,
        groups: groupsOptions[0],
        subgroups: selectedSubGroup,
        stores: selectedSubGroup?.map((el) => el?.stores)?.flat()
      });
    }

    getCategories(
      typeCategory,
      isGroupManage ? selectedSubGroup?.map((el) => el?.stores)?.flat() : ''
    );
  }, [currentUserId]);

  return (
    <Layout>
      <TitleHead title="Categorias" />
      <GlobalStyle />

      <Container>
        {alertErr ? (
          <Alert
            className="w100"
            color="danger"
            isOpen={alertErr}
            toggle={onDismiss}
          >
            Erro ao cadastrar
          </Alert>
        ) : null}

        {alertErrUpdate ? (
          <Alert
            className="w100"
            color="danger"
            isOpen={alertErr}
            toggle={onDismissUpdate}
          >
            Erro ao atualizar
          </Alert>
        ) : null}

        {alertErrDelete ? (
          <Alert
            className="w100"
            color="danger"
            isOpen={alertErr}
            toggle={onDismissDelete}
          >
            Erro ao deletar
          </Alert>
        ) : null}

        {alertErrorDuplicated && (
          <Alert
            className="w100"
            color="danger"
            isOpen={alertErrorDuplicated}
            toggle={closeMessage}
          >
            Uma categoria não pode ter o mesmo nome que a categoria pai ou 2 de
            mesmo nível.
          </Alert>
        )}

        <div style={{ marginTop: 4, marginBottom: 3 }}>
          <PageTitleAndFilter title="Categorias cadastradas" />
        </div>

        <Grid className="cardDefault dFlex flexColumn withoutInputs mb16">
          <div className="dFlex">
            <div style={{ width: '300px' }}>
              <TreeSelectorField
                label="Categorias"
                filterName="categories"
                handleFilter={handleCategorieValue}
                key={(node) => node?.id}
                size="extra_large"
                getFilterhandle={() => {}}
                options={[]}
                inputSizes={{
                  extra_large: 300
                }}
                onFormStyle
              />
            </div>

            <SwitchContainer>
              <div className="pRelative">
                <SwitchField
                  onChange={(isChecked) => {
                    setHiddenProductsAndSkus(isChecked);
                  }}
                  handleFilter={() => {}}
                  onFormStyle
                />
              </div>
              <SwitchDescription>
                Visualizar apenas Categorias
              </SwitchDescription>
            </SwitchContainer>
          </div>
        </Grid>

        <Grid className="cardDefault withoutInputs pRelative">
          {loading && (
            <div style={{ margin: '10px' }}>
              <LinearProgress variant="query" />
            </div>
          )}

          <Tree
            data={dataArray}
            keygen={(node) => node.description}
            defaultExpanded={defaultExpanded}
            renderItem={renderItem}
            className="categoriesTree"
            expandIcons={[
              <img src={categoriesExpand} alt="expandIcon" />,
              <img src={categoriesCollapsed} alt="collapse" />
            ]}
            expanded={expandedTree}
          />

          {typeCategory && (
            <Grid container spacing={12}>
              <Grid
                className={`fixedRootCategories ${
                  !dataArray?.length && 'noLines'
                }`}
              >
                <TextField
                  className="textFieldSmall"
                  placeholder="Adicionar..."
                  size="small"
                  variant="outlined"
                  inputProps={{ maxLength: 50 }}
                  value={addRootCategory}
                  InputLabelProps={{ shrink: true }}
                  required
                  onChange={(e) => {
                    setDescription(e.target.value);
                    setAddRootCategory(e.target.value);
                  }}
                  disabled={!labelManagerHasAllPermissions && !isLabelAdmin}
                />

                <IconButton
                  className="smallIcons"
                  aria-label="check"
                  onClick={addNewObjPai}
                  style={{ outline: 6 }}
                  disabled={
                    isDisableAddOrderCategory || (!labelManagerHasAllPermissions && !isLabelAdmin)
                  }
                >
                  <CheckOutlined size="small" />
                </IconButton>
              </Grid>
            </Grid>
          )}
        </Grid>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Typography
              className="bold textAlignCenter"
              style={{
                fontSize: '18px'
              }}
            >
              {message}
            </Typography>
          </DialogContent>

          <DialogActions className="justifyCenter pb20">
            <Button
              className="defaultButton backButton"
              onClick={handleClose}
              style={{ outline: 0 }}
              color="primary"
            >
              Cancelar
            </Button>

            <Button
              className="defaultButton submitButton"
              onClick={() => removeObj(nodeClick)}
              style={{ outline: 0 }}
              color="primary"
              autoFocus
            >
              Deletar
            </Button>
          </DialogActions>
        </Dialog>
      </Container>

      <CommonAlert
        open={toastError}
        onClose={() => setToastError(false)}
        indexMessage={messageError}
        statusCode={statusCode}
        width="50%"
      />
    </Layout>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(UserActions, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterCategoriesPrinter);
